import { configureStore } from '@reduxjs/toolkit'
import talentReducer from './reducers/talentSlice'
import candidateReducer from './reducers/candidateSlice'

/**
 *
 * @returns
 */
const loadState = () => {
  try {
    const serializedState = sessionStorage.getItem('state')
    if (serializedState === null) {
      return undefined
    }
    return JSON.parse(serializedState)
  } catch (err) {
    return undefined
  }
}

/**
 *
 * @param {*} state
 */
const saveState = (state) => {
  try {
    const serializedState = JSON.stringify(state)
    sessionStorage.setItem('state', serializedState)
  } catch (err) {}
}

const persistedState = loadState()

const store = configureStore({
  reducer: {
    talent: talentReducer,
    candidate: candidateReducer,
  },
  preloadedState: persistedState,
})

store.subscribe(() => {
  saveState(store.getState())
})

export default store
